let resetUrl = 'https://api.xmqxx.com'
let billUrl = 'https://api.xmqxx.com'
export {resetUrl,billUrl}



//////////////////
// WEBPACK FOOTER
// ./url.js
// module id = null
// module chunks = 